export const DAY = 'day';
export const HOUR = 'time';

export default Object.freeze({
  DAY,
  HOUR
});
